/* @generated from adl module ferovinum.app.settlementcredit */

import * as ADL from './../../runtime/adl';
import * as common_db from './../../common/db';
import * as ferovinum_app_db from './db';
import * as ferovinum_app_types from './types';

export interface SettlementCreditDetailsReq {
  currency: ferovinum_app_db.Currency;
  counterpartyRef: ferovinum_app_db.CreditEntityRef;
}

export function makeSettlementCreditDetailsReq(
  input: {
    currency: ferovinum_app_db.Currency,
    counterpartyRef: ferovinum_app_db.CreditEntityRef,
  }
): SettlementCreditDetailsReq {
  return {
    currency: input.currency,
    counterpartyRef: input.counterpartyRef,
  };
}

const SettlementCreditDetailsReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.settlementcredit","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"currency","default":{"kind":"nothing"},"name":"currency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Currency"}},"parameters":[]}},{"annotations":[],"serializedName":"counterpartyRef","default":{"kind":"nothing"},"name":"counterpartyRef","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"CreditEntityRef"}},"parameters":[]}}]}},"name":"SettlementCreditDetailsReq","version":{"kind":"nothing"}}};

export const snSettlementCreditDetailsReq: ADL.ScopedName = {moduleName:"ferovinum.app.settlementcredit", name:"SettlementCreditDetailsReq"};

export function texprSettlementCreditDetailsReq(): ADL.ATypeExpr<SettlementCreditDetailsReq> {
  return {value : {typeRef : {kind: "reference", value : snSettlementCreditDetailsReq}, parameters : []}};
}

export interface SettlementCreditDetails {
  limit: common_db.WithDbId<ferovinum_app_db.SettlementCreditLimit>;
  creditLimit: ferovinum_app_types.MonetaryValue;
  creditLimitUsed: ferovinum_app_types.MonetaryValue;
  creditLimitAvailable: ferovinum_app_types.MonetaryValue;
  paymentTerms: ferovinum_app_db.PaymentTermsPeriod;
  creditFeesPct: ferovinum_app_types.Decimal;
}

export function makeSettlementCreditDetails(
  input: {
    limit: common_db.WithDbId<ferovinum_app_db.SettlementCreditLimit>,
    creditLimit: ferovinum_app_types.MonetaryValue,
    creditLimitUsed: ferovinum_app_types.MonetaryValue,
    creditLimitAvailable: ferovinum_app_types.MonetaryValue,
    paymentTerms: ferovinum_app_db.PaymentTermsPeriod,
    creditFeesPct: ferovinum_app_types.Decimal,
  }
): SettlementCreditDetails {
  return {
    limit: input.limit,
    creditLimit: input.creditLimit,
    creditLimitUsed: input.creditLimitUsed,
    creditLimitAvailable: input.creditLimitAvailable,
    paymentTerms: input.paymentTerms,
    creditFeesPct: input.creditFeesPct,
  };
}

const SettlementCreditDetails_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.settlementcredit","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"limit","default":{"kind":"nothing"},"name":"limit","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"SettlementCreditLimit"}},"parameters":[]}]}},{"annotations":[],"serializedName":"creditLimit","default":{"kind":"nothing"},"name":"creditLimit","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.types","name":"MonetaryValue"}},"parameters":[]}},{"annotations":[],"serializedName":"creditLimitUsed","default":{"kind":"nothing"},"name":"creditLimitUsed","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.types","name":"MonetaryValue"}},"parameters":[]}},{"annotations":[],"serializedName":"creditLimitAvailable","default":{"kind":"nothing"},"name":"creditLimitAvailable","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.types","name":"MonetaryValue"}},"parameters":[]}},{"annotations":[],"serializedName":"paymentTerms","default":{"kind":"nothing"},"name":"paymentTerms","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"PaymentTermsPeriod"}},"parameters":[]}},{"annotations":[],"serializedName":"creditFeesPct","default":{"kind":"nothing"},"name":"creditFeesPct","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.types","name":"Decimal"}},"parameters":[]}}]}},"name":"SettlementCreditDetails","version":{"kind":"nothing"}}};

export const snSettlementCreditDetails: ADL.ScopedName = {moduleName:"ferovinum.app.settlementcredit", name:"SettlementCreditDetails"};

export function texprSettlementCreditDetails(): ADL.ATypeExpr<SettlementCreditDetails> {
  return {value : {typeRef : {kind: "reference", value : snSettlementCreditDetails}, parameters : []}};
}

export type SettlementCreditDetailsResp = (SettlementCreditDetails|null);

const SettlementCreditDetailsResp_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.settlementcredit","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.settlementcredit","name":"SettlementCreditDetails"}},"parameters":[]}]}}},"name":"SettlementCreditDetailsResp","version":{"kind":"nothing"}}};

export const snSettlementCreditDetailsResp: ADL.ScopedName = {moduleName:"ferovinum.app.settlementcredit", name:"SettlementCreditDetailsResp"};

export function texprSettlementCreditDetailsResp(): ADL.ATypeExpr<SettlementCreditDetailsResp> {
  return {value : {typeRef : {kind: "reference", value : snSettlementCreditDetailsResp}, parameters : []}};
}

export interface CreateOrUpdateSettlementCreditReq {
  counterpartyRef: ferovinum_app_db.CreditEntityRef;
  currency: ferovinum_app_db.Currency;
  limit: number;
  paymentTerms: ferovinum_app_db.PaymentTermsPeriod;
  creditFeesPct: ferovinum_app_types.Decimal;
}

export function makeCreateOrUpdateSettlementCreditReq(
  input: {
    counterpartyRef: ferovinum_app_db.CreditEntityRef,
    currency: ferovinum_app_db.Currency,
    limit: number,
    paymentTerms: ferovinum_app_db.PaymentTermsPeriod,
    creditFeesPct: ferovinum_app_types.Decimal,
  }
): CreateOrUpdateSettlementCreditReq {
  return {
    counterpartyRef: input.counterpartyRef,
    currency: input.currency,
    limit: input.limit,
    paymentTerms: input.paymentTerms,
    creditFeesPct: input.creditFeesPct,
  };
}

const CreateOrUpdateSettlementCreditReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.settlementcredit","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"counterpartyRef","default":{"kind":"nothing"},"name":"counterpartyRef","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"CreditEntityRef"}},"parameters":[]}},{"annotations":[],"serializedName":"currency","default":{"kind":"nothing"},"name":"currency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Currency"}},"parameters":[]}},{"annotations":[],"serializedName":"limit","default":{"kind":"nothing"},"name":"limit","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"paymentTerms","default":{"kind":"nothing"},"name":"paymentTerms","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"PaymentTermsPeriod"}},"parameters":[]}},{"annotations":[],"serializedName":"creditFeesPct","default":{"kind":"nothing"},"name":"creditFeesPct","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.types","name":"Decimal"}},"parameters":[]}}]}},"name":"CreateOrUpdateSettlementCreditReq","version":{"kind":"nothing"}}};

export const snCreateOrUpdateSettlementCreditReq: ADL.ScopedName = {moduleName:"ferovinum.app.settlementcredit", name:"CreateOrUpdateSettlementCreditReq"};

export function texprCreateOrUpdateSettlementCreditReq(): ADL.ATypeExpr<CreateOrUpdateSettlementCreditReq> {
  return {value : {typeRef : {kind: "reference", value : snCreateOrUpdateSettlementCreditReq}, parameters : []}};
}

export type CreateOrUpdateSettlementCreditResp = 'success' | 'creditLimitTooLow' | 'creditLimitExceeded' | 'invalidCurrency';
export const valuesCreateOrUpdateSettlementCreditResp : CreateOrUpdateSettlementCreditResp[] = ['success', 'creditLimitTooLow', 'creditLimitExceeded', 'invalidCurrency'];

const CreateOrUpdateSettlementCreditResp_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.settlementcredit","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"success","default":{"kind":"nothing"},"name":"success","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"creditLimitTooLow","default":{"kind":"nothing"},"name":"creditLimitTooLow","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"creditLimitExceeded","default":{"kind":"nothing"},"name":"creditLimitExceeded","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"invalidCurrency","default":{"kind":"nothing"},"name":"invalidCurrency","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"CreateOrUpdateSettlementCreditResp","version":{"kind":"nothing"}}};

export const snCreateOrUpdateSettlementCreditResp: ADL.ScopedName = {moduleName:"ferovinum.app.settlementcredit", name:"CreateOrUpdateSettlementCreditResp"};

export function texprCreateOrUpdateSettlementCreditResp(): ADL.ATypeExpr<CreateOrUpdateSettlementCreditResp> {
  return {value : {typeRef : {kind: "reference", value : snCreateOrUpdateSettlementCreditResp}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.app.settlementcredit.SettlementCreditDetailsReq" : SettlementCreditDetailsReq_AST,
  "ferovinum.app.settlementcredit.SettlementCreditDetails" : SettlementCreditDetails_AST,
  "ferovinum.app.settlementcredit.SettlementCreditDetailsResp" : SettlementCreditDetailsResp_AST,
  "ferovinum.app.settlementcredit.CreateOrUpdateSettlementCreditReq" : CreateOrUpdateSettlementCreditReq_AST,
  "ferovinum.app.settlementcredit.CreateOrUpdateSettlementCreditResp" : CreateOrUpdateSettlementCreditResp_AST
};
